import { useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import '../../css/LocalFilters.css';

const LocalFiltersModal = ({
    title = 'Filtres locaux',
    description,
    onClose,
    onValidate,
    children
}) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    return (
        <div className="local-filters-modal-overlay" onClick={onClose}>
            <section
                className="local-filters-modal"
                role="dialog"
                aria-modal="true"
                aria-label={title}
                onClick={(event) => event.stopPropagation()}
            >
                <header className="local-filters-modal-header">
                    <div className="local-filters-modal-heading">
                        <span className="local-filters-modal-icon" aria-hidden="true">
                            <TuneIcon fontSize="small" />
                        </span>
                        <div>
                            <h2 className="local-filters-modal-title">{title}</h2>
                            {description ? (
                                <p className="local-filters-modal-description">{description}</p>
                            ) : null}
                        </div>
                    </div>

                    <div className="local-filters-modal-actions">
                        <button
                            type="button"
                            className="local-filters-button local-filters-button--secondary"
                            onClick={onClose}
                        >
                            <CloseIcon fontSize="small" />
                            <span>Fermer</span>
                        </button>
                        <button
                            type="button"
                            className="local-filters-button local-filters-button--primary"
                            onClick={onValidate}
                        >
                            <CheckIcon fontSize="small" />
                            <span>Valider</span>
                        </button>
                    </div>
                </header>

                <div className="local-filters-modal-body">
                    {children}
                </div>
            </section>
        </div>
    );
};

export default LocalFiltersModal;
